import { AuthEvents, selectLoginError, selectAccessToken } from '@nike/oauth-client';
import jwtDecode from 'jwt-decode';

export const SET_AD_GROUPS = 'SET_AD_GROUPS';

const events = new AuthEvents();

// Store navigation function for later use
let navigateFunction: any = null;

export const setNavigateFunction = (nav: any) => {
  navigateFunction = nav;
};

events.on('loginSuccess', (dispatch, getState) => {
  const state = getState().auth;

  // Redirect to dashboard or previous location after successful login
  if (navigateFunction) {
    const targetPath = state.previousLocation?.pathname || '/dashboard';
    navigateFunction(targetPath, { replace: true });
  }

  const token = selectAccessToken(getState());
  
  // Set token in Authorization header for API calls
  if (token) {
    // You can add this to your Apollo client or axios instance
    localStorage.setItem('access_token', token);
    
    // Decode token to get AD groups and user info
    const decoded: any = jwtDecode(token);
    const adGroups = decoded?.groups || [];

    // Get email from various possible fields
    const userEmail = decoded?.email || decoded?.upn || decoded?.unique_name || decoded?.sub || 'Unknown User';
    
    // Extract name from various possible JWT fields
    // Nike Okta may use: name, given_name + family_name, displayName, or cn
    let userName = 'User';
    if (decoded?.name) {
      userName = decoded.name;

    } else if (decoded?.given_name || decoded?.family_name) {
      userName = `${decoded?.given_name || ''} ${decoded?.family_name || ''}`.trim();

    } else if (decoded?.displayName) {
      userName = decoded.displayName;

    } else if (decoded?.cn) {
      userName = decoded.cn;

    } else if (decoded?.preferred_username) {
      userName = decoded.preferred_username;

    } else if (userEmail && userEmail.includes('@')) {
      // Extract name from email (e.g., "Sravani.Kandula@nike.com" -> "Sravani Kandula")
      const emailName = userEmail.split('@')[0];
      userName = emailName
        .split('.')
        .map((part: string) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');

    } else {

    }
    
    // Store user information for display on dashboard
    const userInfo = {
      email: userEmail,
      name: userName,
      sub: decoded?.sub,
      groups: adGroups
    };
    localStorage.setItem('user_info', JSON.stringify(userInfo));

    dispatch({
      type: SET_AD_GROUPS,
      payload: adGroups
    });
  }
});

events.on('loginError', (dispatch, getState) => {
  const loginError = selectLoginError(getState());

  if (loginError) {
    console.error('Login error:', loginError);
    // You can dispatch a notification action here
  }
});

events.on('refreshSuccess', (dispatch, getState) => {
  const token = selectAccessToken(getState());
  if (token) {
    localStorage.setItem('access_token', token);
  }
});

events.on('refreshError', (dispatch, getState) => {
  const loginError = selectLoginError(getState());

  if (loginError) {
    console.error('Refresh error:', loginError);
  }
});

events.on('logoutSuccess', (dispatch, getState) => {
  // Clear all authentication tokens from localStorage
  localStorage.removeItem('access_token');
  localStorage.removeItem('user_info');
  localStorage.removeItem('@qr-redirect-automation-ui/tokens');
  localStorage.removeItem('@qr-redirect-automation-ui/hydrate');
  
  // Clear sessionStorage as well
  sessionStorage.clear();

  window.location.href = '/';
});

events.on('logoutError', () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('user_info');
  localStorage.removeItem('@qr-redirect-automation-ui/tokens');
  localStorage.removeItem('@qr-redirect-automation-ui/hydrate');
  sessionStorage.clear();

  window.location.href = '/';
});

export default events;

